"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRefineModalBody = exports.StyledRefineModalRoot = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledRefineModalRoot = (0, styled_components_1.default)(material_1.Box) `
  && {
    background: ${ui_components_1.baseColors.background100};
  }
`;
exports.StyledRefineModalBody = (0, styled_components_1.default)(material_1.Box) `
  && {
    padding: 0 ${({ theme }) => theme.spacing(2.5)};
    .RefineModal-Accordion-Wrap {
      border-radius: 0.5rem;
      background: ${({ theme }) => theme.palette.common.white};
      > div {
        padding: ${({ theme }) => theme.spacing(1.6)};
      }
    }
  }
`;
